import { render, staticRenderFns } from "./columns_table.vue?vue&type=template&id=c6047acc"
import script from "./columns_table.vue?vue&type=script&lang=js"
export * from "./columns_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports